import React from 'react'
import EmailVerificationEnvelopeIllustration from './EmailVerificationEnvelopeIllustration'

// Only rendered for the chained verify-primary -> add-backup journey, so step 1
// is always shown already completed by the time this appears.
const EmailVerificationStepper = (props) => {
  const { backupVerified } = props
  return (
    <div className='emailVerificationFlow-stepper'>
      <div className='emailVerificationFlow-stepper-step'>
        <EmailVerificationEnvelopeIllustration
          className='emailVerificationFlow-stepper-icon'
          checkColor='#30C99C'
          width={32}
          height={26}
        />
        <div className='emailVerificationFlow-stepper-label'>Verify email</div>
      </div>
      <div className='emailVerificationFlow-stepper-line emailVerificationFlow-stepper-line--done' />
      <div className='emailVerificationFlow-stepper-step'>
        {backupVerified ? (
          <div className='emailVerificationFlow-stepper-circle emailVerificationFlow-stepper-circle--done'>✓</div>
        ) : (
          <div className='emailVerificationFlow-stepper-circle emailVerificationFlow-stepper-circle--active'>2</div>
        )}
        <div className='emailVerificationFlow-stepper-label emailVerificationFlow-stepper-label--active'>Add backup</div>
      </div>
    </div>
  )
}

EmailVerificationStepper.defaultProps = {
  backupVerified: false,
}

export default EmailVerificationStepper
